import { booleanAttribute, Component, computed, HostBinding, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';

/**
 * @deprecated Use the new `glxy-chat-message-group` component instead
 */
@Component({
  selector: 'glxy-chat-bubble',
  templateUrl: './chat-bubble.component.html',
  styleUrls: ['./chat-bubble.component.scss'],
  imports: [GalaxyAvatarModule, MatTooltipModule],
})
export class ChatBubbleComponent {
  @HostBinding('class') class = 'glxy-chat-bubble';

  readonly type = input<'sent' | 'received'>('received');
  readonly messageText = input<string | undefined>(undefined);
  readonly messageFrom = input<string | undefined>(undefined);
  readonly messageMetadata = input<string | undefined>(undefined);
  readonly profilePicUrl = input<string | undefined>(undefined);
  readonly profileSVGIcon = input<string | undefined>(undefined);
  readonly profileBackgroundColor = input<string | undefined>(undefined);
  readonly profileSourceIconUrl = input<string | undefined>(undefined);
  readonly showProfilePic = input<boolean | 'auto'>('auto');
  readonly sentFromYou = input(true, { transform: booleanAttribute });
  readonly isTyping = input(false, { transform: booleanAttribute });

  protected readonly shouldShowProfilePic = computed(() => {
    return (
      this.showProfilePic() === true ||
      (this.type() === 'received' && this.showProfilePic() !== false) ||
      (this.type() === 'sent' && !this.sentFromYou() && this.showProfilePic() !== false)
    );
  });

  protected readonly profilePicCSS = computed(() => {
    return this.profilePicUrl() ? 'url(' + this.profilePicUrl() + ')' : '';
  });

  protected readonly profileSourceIconCSS = computed(() => {
    return this.profileSourceIconUrl() ? 'url(' + this.profileSourceIconUrl() + ')' : '';
  });
}
